/* eslint-disable import/prefer-default-export */

export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const USE_LOCAL = true;
// eslint-disable-next-line no-nested-ternary
export const API_BASE_URL = (IS_PRODUCTION || !USE_LOCAL) ? 'https://api.almaceleste.cl' : 'http://localhost:41002';
